import { TextColorType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLParagraphElement>["className"];
  color?: TextColorType;
  fontWeight?: 400 | 500 | 600;
  id?: HTMLAttributes<HTMLParagraphElement>["id"];
  lineHeight?: string;
  size?: "caption" | "sm" | "md" | "lg";
  style?: CSSProperties;
  textAlign?: CSSProperties["textAlign"];
}>;

export default function LI({
  children,
  className,
  color,
  fontWeight,
  id,
  lineHeight,
  size,
  style,
  textAlign,
}: Props) {
  const styles: CSSProperties = {
    color: `var(--color-text-${color || "primary"})`,
    fontSize:
      size === "caption"
        ? "var(--font-size-caption)"
        : `var(--font-size-body-${size || "md"})`,
    fontWeight: fontWeight || 400,
    lineHeight: lineHeight || "var(--line-height-default)",
    textAlign: textAlign || "start",
    ...style,
  };

  return (
    <li className={className} id={id} style={styles}>
      {children}
    </li>
  );
}
